<template>
    <div class="bb bg-near-white b--light-gray flex flex-wrap  items-center justify-between ph3 ph4-ns">
        
        <h4 class="pv3 mr2">{{heading}}</h4>

        <Spinner v-if="hasData && loading" size="medium" line-fg-color="#000" line-bg-color="#fb0"/>
        
        <router-link :to="route" class="grow flex no-underline" v-if="seeAll && !loading">
            <h6 class="yellow mr2 pv1">See All</h6>
            <img src="@/assets/img/icon_forward_simple_yellow.svg">
        </router-link >

    </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {
    props: {
        heading: {
            type: String,
            required: true
        },
        seeAll: {
            type: Boolean,
            default: false
        },
        route: {
            type: String
        },
        hasData: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean
        }
    },
    components: {
        Spinner
    }
};
</script>
